// Shared list of property types across the app.
// The value is stored in DB; the label is user-facing (multilingual).
export const PROPERTY_TYPES = [
  { value: "villa", it: "Villa", en: "Villa", he: "וילה", ru: "Вилла" },
  { value: "apartment", it: "Appartamento", en: "Apartment", he: "דירה", ru: "Квартира" },
  { value: "penthouse", it: "Attico", en: "Penthouse", he: "פנטהאוז", ru: "Пентхаус" },
  { value: "loft", it: "Loft", en: "Loft", he: "לופט", ru: "Лофт" },
  { value: "townhouse", it: "Villetta a schiera", en: "Townhouse", he: "בית טורי", ru: "Таунхаус" },
  { value: "commercial", it: "Commerciale", en: "Commercial", he: "מסחרי", ru: "Коммерческая" },
  { value: "office", it: "Ufficio", en: "Office", he: "משרד", ru: "Офис" },
  { value: "land", it: "Terreno", en: "Land", he: "קרקע", ru: "Земля" },
  { value: "hotel", it: "Hotel / Struttura ricettiva", en: "Hotel / Hospitality", he: "מלון", ru: "Отель" },
  { value: "other", it: "Altro", en: "Other", he: "אחר", ru: "Другое" },
];

/** Return the human-readable label for a property_type value in the given lang. */
export function propertyTypeLabel(value, lang = "it") {
  if (!value) return "";
  const item = PROPERTY_TYPES.find((p) => p.value === value);
  if (!item) return value;
  return item[lang] || item.it || value;
}
